angular.module('impactx.invoice').controller('PercentageDistributionCtrl', [
    '$scope',
    '$mdDialog',
    'dataGen',
    'blhId',
    PercentageDistributionCtrl
]);

function PercentageDistributionCtrl($scope, $mdDialog, dataGen, blhId) {
    var ctrl = this;

    dataGen.getData($scope, {id: blhId, useOnlyDni: false}, '/invoice/complaint/distribute/view');

    ctrl.cancel = function () {
        $mdDialog.cancel();
    };

    ctrl.save = function () {
        dataGen.postAsForm($scope, {matrix: $scope.data}, '/invoice/complaint/distribute/save').then(function () {
            $mdDialog.hide();
        });
    };

    ctrl.changeOnlyDni = function () {
        dataGen.getData($scope, {id: blhId, useOnlyDni: $scope.data.onlyDni.value}, '/invoice/complaint/distribute/view');
    };
}